import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';

@Component({
  selector: 'app-remove-caller-id-modal',
  templateUrl: './remove-caller-id-modal.component.html',
  styleUrls: ['./remove-caller-id-modal.component.scss']
})
export class RemoveCallerIdModalComponent implements OnInit {

  callerIdData:any;

  btnStatus: boolean = false;

  authToken = localStorage.getItem("token")

  constructor(
    public clipBoardService: ClipBoardService,
    private snackBar: MatSnackBar,
    private serverService: ServerService,
    private dialogRef: MatDialogRef<RemoveCallerIdModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
    ) {
      this.callerIdData=data
    }

  ngOnInit(): void {
  }

  delCallerId(id:any) {

    this.btnStatus = true;

    this.serverService.delCallerId(id, this.authToken).subscribe(
      data => {
        this.btnStatus = false;
        this.dialogRef.close(data);
        this.clipBoardService.showMessgeInText("Caller ID Delete Succesfully", "success-snackbar");
      },
      err => {
        let message = JSON.parse(err._body);
        if (err.status == 422) {
          this.clipBoardService.showMessgeInText(JSON.stringify(message.errors), "error-snackbar");
        } else {
          this.clipBoardService.checkServerError(err, this.authToken)
        }
        this.btnStatus = false;
      }
    )
  }

  close() {
    this.dialogRef.close();
  }

}
